export const mapSubtypes = (subtype: string): string => {
  if (subtype && subtype.length > 0) {
    const splitString = subtype.split('_')
    let finalString = splitString[0].charAt(0).toUpperCase() + splitString[0].slice(1)
    for (let word of splitString.slice(1)) finalString = finalString + ' ' + word
    return finalString
  }
  return ''
}
